module.exports = "<div class=\"col-lg-12 np\">\r\n<div id=\"map\" style=\"height:750px;\"></div>\r\n</div>\r\n{{zoomLevel}}<!--\r\n<table class=\"table-striped table-hover custom-table\">\r\n  <tbody>\r\n    <tr *ngFor=\"let row of cities\">\r\n      <td class=\"td\">{{row.Name}}</td>\r\n\r\n    </tr>\r\n  </tbody>\r\n</table>-->"


//////////////////
// WEBPACK FOOTER
// ./src/app/component/map/map.component.html
// module id = ./src/app/component/map/map.component.html
// module chunks = main